import { BUILDER_TYPE } from '../actions/builderType';
import { BUILDER_TYPES } from '../../config/constants';


export default (state = BUILDER_TYPES.FORM, action) => {
    switch (action.type) {
        case BUILDER_TYPE:
            return state = action.payload;

        default: return state;
    }
}